import { gql } from '@apollo/client'
import { Demande } from '../fragment/demande.fragment'

/**
 * Demande Table
 */
export const DEMANDES = gql`
  query Demandes(
    $trigramme: String!
    $order_by: [d4_fn_view_demande_order_by!]!
    $where: d4_fn_view_demande_bool_exp!
  ) {
    demandes: d4_demandes(
      args: { trg: $trigramme }
      order_by: $order_by
      where: $where # limit: $limit # offset: $offset
    ) {
      ...Demande
    }
  }
  ${Demande.fragments.demande}
`
/**
 * Demande Drawer
 */
export const EVENEMENTS = gql`
  query Evenement($id: bigint!) {
    demande: d4_demande_one(args: { demandeid: $id }) {
      ...Demande
      equipement {
        id
        fournisseur_favori_equipements {
          id
          societe_id
          societe {
            id
            raisonsociale
          }
        }
      }
      evenements(order_by: { dateevenement: desc }) {
        ...Evenement
        form {
          id
          data
          created_at
        }
        tags {
          id
          tag_id
          tagevenement {
            id
            libelle
          }
        }
      }
    }
  }
  ${Demande.fragments.demande}
  ${Demande.fragments.evenement}
`
/**
 * TODO: remplacer par d4_fn_view_demande
 */
/**
  TODO: virer l'equipement id sinon les sinistres ne remontes pas
*/

export const DEMANDE_BY_EQUIPEMENT = gql`
  query DemandeByEquipement($contextId: bigint!, $batimentId: bigint, $equipementId: bigint) {
    demandes: d4_demande(
      where: {
        _and: [
          { datecloturepard4: { _is_null: true } }
          { datecloturedefinitive: { _is_null: true } }
          {
            _or: [
              {
                copropriete_id: { _eq: $contextId }
                equipement: {
                  typeequipement_id: { _eq: $equipementId }
                  _or: [{ batiment_id: { _eq: $batimentId } }, { copropriete_id: { _eq: $batimentId } }]
                }
              }
              { personne: { id: { _eq: $contextId } } }
            ]
          }
          {
            _or: [
              { dtype: { _like: "Demande%" } }
              { dtype: { _like: "Sinistre%" } }
              { dtype: { _like: "Procedure%" } }
            ]
          }
        ]
      }
    ) {
      id
      description
      personne {
        nom
        prenom
      }
      copropriete {
        trigramme
        id
      }
      equipement {
        typeequipement_id
        id
        libelle
        copropriete_id
        batiment_id
      }
    }
  }
`

export const DEMANDE_BY_ID = gql`
  query DemandeByEquipement($id: bigint!) {
    demande: d4_demande_by_pk(id: $id) {
      id
      description
      personne {
        nom
        prenom
      }
      copropriete {
        trigramme
        id
      }
      equipement {
        typeequipement_id
        id
        libelle
        copropriete_id
        batiment_id
      }
    }
  }
`

export const SINISTRE_BY_ID = gql`
  query DemandeByEquipement($id: bigint!) {
    demande: d4_demande_by_pk(id: $id) {
      id
      description
      naturesinistre
      coproprietaireorigine_id
      typeoriginesinistre
      typelesesinistre
      coproprietairelese_id
    }
  }
`

export const DEMANDE_RAPPEL_QUERY = gql`
  query DemandeRappel($emetteurId: bigint!) {
    demandes: d4_demande(
      order_by: { dateappel: desc }
      where: { _and: [{ dtype: { _eq: "DemandeDeRappel" } }, { emetteur_id: { _eq: $emetteurId } }] }
    ) {
      id
      description
      dateappel
      rappel {
        id
        texte
        etatrappeltelephonique
        daterappel
        auteur {
          numerodeposte
          id
          nom
          prenom
        }
      }
      gestionnairequidoitrappeler {
        nom
        prenom
        id
      }
      personne {
        id
        nom
        prenom
        telportable
        telfixe
      }
    }
  }
`

export const DEMANDES_A_TRAITER_QUERY = gql`
  query DemandesATraiter($gestionnaireId: bigint!) {
    d4_copropriete(
      where: {
        _or: [{ gestionnaire_id: { _eq: $gestionnaireId } }, { gestionnairesedentaire_id: { _eq: $gestionnaireId } }]
        _and: { statutcopropriete: { _eq: 0 } }
      }
    ) {
      id
      trigramme
      demandes(
        where: {
          _and: [{ datedernierimportmailatraiter: { _is_null: false } }, { datecloturedefinitive: { _is_null: true } }]
        }
        order_by: { datedernierimportmailatraiter: desc }
      ) {
        id
        description
        datedernierimportmailatraiter
      }
    }
  }
`
